import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FilesHubSxSLayerView } from 'owa-group-files-hub';
import { getSxSViewStore as getSPFilePreviewStore } from 'owa-group-files-hub-store';
import { PreviewPaneMode } from 'owa-sxsdata';

const styles = require('./GroupFilesHubSxSLayerView.scss');

export const GroupFilesHubSxSLayerView = observer(function GroupFilesHubSxSLayerView(props: {}) {
    const viewState = getSPFilePreviewStore().viewState;
    if (
        viewState &&
        viewState.previewPane &&
        viewState.previewPane.mode !== PreviewPaneMode.Blank
    ) {
        // Preview SP file in new sxs.
        return (
            <div className={styles.SxSView}>
                <FilesHubSxSLayerView />
            </div>
        );
    }

    return null;
});
